import Title from './Title';

const title = new Title();

export default title;
